import ReqError from "@source/api/reqError";
import {api} from "@source/api/http";
import {DEFAULT_NOTIFICATIONS_LIMIT, IEmployeeNotification, IGetNotificationsRequest, IUnreadNotificationsCount} from "@source/api/models/notificationModels";

export default class NotificationService {
  static async getNotifications(req: IGetNotificationsRequest) {
    try {
      const page = req.page || 0;
      const limit = req.limit || DEFAULT_NOTIFICATIONS_LIMIT;
      const status = req.status || "all";
      return (await api.get<IEmployeeNotification[]>(`in-app-notifications?status=${status}&page=${page}&limit=${limit}`)).data;
    } catch (e: any) {
      const downError = ReqError.handleServerDownError(e);
      if (downError) {
        throw downError;
      }
      throw ReqError.getNotifications(e.response);
    }
  }

  static async getUnreadCount() {
    try {
      return (await api.get<IUnreadNotificationsCount>("in-app-notifications/unread-count")).data;
    } catch (e: any) {
      const downError = ReqError.handleServerDownError(e);
      if (downError) {
        throw downError;
      }
      throw ReqError.getUnreadNotificationsCount(e.response);
    }
  }
}
